/* eslint-disable no-plusplus */
/* eslint-disable no-case-declarations */
/* eslint-disable no-restricted-syntax */
import { HttpHeaders } from '@angular/common/http';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import localeEN from 'date-fns/locale/en-US';
import locale from 'date-fns/locale/es';
import localePT from 'date-fns/locale/pt-BR';
import * as moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { AppState } from 'src/app/app.reducer';
import * as commonActions from 'src/app/common/common.actions';
import * as Constant from 'src/app/common/constant/constant';
import { getProduct } from 'src/app/multi_product/policy/generic-input/inputs-names-utils';
import { ICatalogService } from 'src/app/multi_product/services/interfaces/catalog_service.interface';
import { CataloguesService } from 'src/app/quote/services/http/catalog-services';
import { environment as env } from 'src/environments/environment';
import { LocalStorageService } from '../services/local-storage.service';

const localStorageService = new LocalStorageService();

export const breakReference = (data: any) => {
  try {
    return JSON.parse(JSON.stringify(data));
  } catch (error) {
    console.error(error);
    return data;
  }
};

export const getCountryCode = () => {
  if (env.COUNTRY.includes('mp')) {
    return env.COUNTRY.split('-')[1].toUpperCase();
  }
  return env.COUNTRY.toUpperCase();
};

export const isCountryMX = (): boolean => {
  const countryCode = getCountryCode();
  return countryCode === 'MX';
};

export const isCountryBR = (): boolean => {
  const countryCode = getCountryCode();
  return countryCode === 'BR';
};

export const isCountryPE = (): boolean => {
  const countryCode = getCountryCode();
  return countryCode === 'PE';
};

export const isCountryUS = (): boolean => {
  const countryCode = getCountryCode();
  return countryCode === 'US';
};

export const mapStatesList = (states: any[]): { name: string; key: string }[] => {
  if (isCountryMX()) {
    states = states.filter((state) => state.code !== 'POLIZA_SUSPENDIDA');
  }
  return states.map((state) => ({ name: state.name, key: state.code }));
};

export const getCountryCodeLogin = () => env.COUNTRY.toUpperCase();

export const checkURL = () => {
  const url = window.location.href;
  const regex = /public\/([^/]*)\//;
  const match = url.match(regex);

  if (match && match[1]) return match[1].toUpperCase();

  return 'MX';
};

export const getCatalogue = async (
  group: string,
  cataloguesService: CataloguesService,
  store: Store<AppState>,
  parseCatalogData?: Function,
  discardValues: Array<string> = []
) => {
  try {
    const catalogData = await firstValueFrom(cataloguesService.getCatalog(group, getCountryCode()));

    return parseCatalogData ? parseCatalogData(catalogData, discardValues) : catalogData;
  } catch (error) {
    store.dispatch(
      commonActions.viewToast({
        message: 'Algo salió mal, intente nuevamente',
      })
    );
    return {};
  }
};

export const getCatalogueMP = async (
  group: string,
  catalogsServiceMP: ICatalogService,
  store: Store<AppState>,
  parseCatalogData?: Function,
  discardValues: Array<string> = [],
  headers?: HttpHeaders
) => {
  try {
    const catalogData = await firstValueFrom(catalogsServiceMP.getCatalogue(group, headers));

    return parseCatalogData ? parseCatalogData(catalogData, discardValues) : catalogData;
  } catch (error) {
    store.dispatch(
      commonActions.viewToast({
        message: 'Algo salió mal al obtener el catalogo, intente nuevamente',
      })
    );
    return [];
  }
};

export function formatNumber(number: number | Number): string {
  const formattedNumber = number.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formattedNumber;
}

export function formatNumberRate(number: number | Number): string {
  return number.toFixed(10);
}

export const delay = async (ms) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

export function isNumeric(data: any): boolean {
  return !Number.isNaN(Number(data));
}

export function setDate(date: string) {
  if (date) {
    return moment(date).toDate();
  }
  return new Date();
}

export function getKeyByValue(searchValue: string, options: any) {
  const foundObj = options.find((obj: any) => obj.name === searchValue);
  return foundObj ? foundObj.key : undefined;
}

export function formatDate(startDate: any, format: string = 'DD/MM/YYYY'): string {
  if (startDate) {
    return moment(startDate).format(format);
  }
  return '';
}
const scrollToFirstError = (form: FormGroup) => {
  const firstError = Object.keys(form.controls).find((control) => form.controls[control].invalid);

  if (firstError) {
    const element = document.querySelector(`#${firstError}`);
    if (element) {
      const offset = 150;
      const elementRect = element.getBoundingClientRect();
      const elementY = elementRect.top + window.scrollY;
      window.scrollTo({ top: elementY - offset, behavior: 'smooth' });
      return true;
    }
  }
  return false;
};

export const handleInvalidForms = (...forms: FormGroup[]) => {
  let scrollExecuted = false;
  forms.forEach((form) => {
    form.markAllAsTouched();
    if (!scrollExecuted) scrollExecuted = scrollToFirstError(form);
  });
};

export const formatCNPJ = (value: string) => {
  const cnpjValue = value.replace(/\s+/g, '').substr(0, 14);
  const partitions = [2, 3, 3, 4, 2];
  const numbers = [];

  let position = 0;
  partitions.forEach((partition, index) => {
    const part = cnpjValue.substr(position, partition);
    if (part) {
      numbers.push(part);
      if (index === 0 || index === 1) numbers.push('.');
      if (index === 2) numbers.push('/');
      if (index === 3) numbers.push('-');
    }
    position += partition;
  });

  return numbers.join('');
};

export const getUserName = () => localStorageService.get('username');

export const returnForCountry = () => {
  let language = {};
  const countryCode = getCountryCode().toLowerCase();
  if (countryCode === 'br') {
    language = { ...localePT };
  } else if (countryCode === 'us') {
    language = { ...localeEN };
  } else {
    language = { ...locale };
  }
  return { language };
};

export const toDateTimeISO8601 = (fechaString, horaString) => {
  const fecha = moment(fechaString, 'DD/MM/YYYY');
  const hora = moment(horaString, 'HH:mm:ss');

  const fechaHora = moment.utc({
    year: fecha.year(),
    month: fecha.month(),
    day: fecha.date(),
    hour: hora.hours(),
    minute: hora.minutes(),
    second: hora.seconds(),
  });

  return fechaHora.toDate();
};

export const dateWithAddDays = (addDays: number) => {
  const date = new Date();
  date.setDate(date.getDate() + addDays);
  return date;
};

export const getFileExtension = (nombreArchivo) => {
  const extensionesDosCaracteres = new Set(['ai', '7z', 'gz']);
  const extensionesTresCaracteres = new Set([
    'txt',
    'ods',
    'xls',
    'csv',
    'odt',
    'doc',
    'rtf',
    'wpd',
    'ppt',
    'odp',
    'pps',
    'tif',
    'jpg',
    'gif',
    'bmp',
    'png',
    'eps',
    'raw',
    'pdf',
    'zip',
    'rar',
    'tar',
    'msg',
  ]);
  const extensionesCuatroCaracteres = new Set([
    'xlsm',
    'xlsx',
    'docx',
    'jpeg',
    'svg',
    'psd',
    'jpeg',
    'bz2',
    'arj',
  ]);

  const ultimosCuatro = nombreArchivo.slice(-4).toLowerCase();

  if (extensionesCuatroCaracteres.has(ultimosCuatro)) {
    return ultimosCuatro;
  }

  const ultimosTres = nombreArchivo.slice(-3).toLowerCase();

  if (extensionesTresCaracteres.has(ultimosTres)) {
    return ultimosTres;
  }

  const ultimosDos = nombreArchivo.slice(-2).toLowerCase();

  if (extensionesDosCaracteres.has(ultimosDos)) {
    return ultimosDos;
  }

  return '';
};

export const replacer = (key, value) => {
  if (value instanceof Map) {
    let obj = {};
    obj = Array.from(value.entries()).reduce((acc, [k, v]) => {
      acc[k] = v;
      return acc;
    }, {});
    return obj;
  }
  return value;
};

export const reviver = (value) => {
  if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
    const entries = Object.entries(value);
    if (entries.length > 0 && entries.every(([k]) => typeof k === 'string')) {
      return new Map(entries);
    }
  }
  return value;
};

export function getUserRol(): string {
  let userRol: string;
  if (env.COUNTRY !== 'mp') return `COUNTRY: ${env.COUNTRY}`;
  const userGroup = localStorageService.get('brokerSessionInfo').groups;
  userGroup.forEach((group: any) => {
    Constant.ROLES.forEach((rol: string) => {
      if (group.name === rol) userRol = rol;
      return 'No MP user rol';
    });
  });
  return userRol;
}

export function getIfUserHasRole(role: string): boolean {
  if (env.COUNTRY !== 'mp') return false;
  const userGroups: any[] = localStorageService.get('brokerSessionInfo').groups;
  return userGroups?.some((group: any) => group?.name === role);
}

export function getMultipleUserRolBoolean(data: any): boolean {
  const userGroup = localStorageService.get('brokerSessionInfo').groups;
  const userRoles = [];
  let includeBoolean = false;

  if (env.COUNTRY !== 'mp') return false;
  userGroup.forEach((group: any) => {
    if (Constant.ROLESobj[group.name.split('-').join('_')]) userRoles.push(group.name);
  });

  // revisar cuando son muchos roles con muchas verificaciones o una verificacion con muchos roles

  if (Array.isArray(data)) {
    data.forEach((rol: string) => {
      if (userRoles.includes(rol) && !includeBoolean) includeBoolean = true;
    });
  } else includeBoolean = userRoles.includes(data);
  return includeBoolean;
}

export function getMultipleUserRolNames(): any {
  const userGroup = localStorageService.get('brokerSessionInfo').groups;
  const userRoles = [];

  if (!env.COUNTRY.includes('mp')) return '';
  userGroup.forEach((group: any) => {
    if (Constant.ROLESobj[group.name.split('-').join('_')]) userRoles.push(group.name);
  });

  return userRoles;
}

export function isCumplimientoUser(): boolean {
  return getMultipleUserRolNames().includes('ARTICO-MP-CUMPLIMIENTO');
}

export function isCommercialMPUser(): boolean {
  return getMultipleUserRolNames().includes('ARTICO-MP-COMERCIAL');
}

export function isPracticingMPUser(): boolean {
  return getMultipleUserRolNames().includes('ARTICO-MP-COMERCIAL-PRACTICANTE');
}

export function isOperationMPUser(): boolean {
  return getMultipleUserRolNames().includes('ARTICO-MP-OPERACIONES');
}

export function isSuscriptionMPUser(): boolean {
  return getMultipleUserRolNames().includes('ARTICO-MP-SUSCRIPCION');
}

export function isCumplimientoMPUser(): boolean {
  return getMultipleUserRolNames().includes('ARTICO-MP-CUMPLIMIENTO');
}

export function isAdminMPUser(): boolean {
  return getMultipleUserRolNames().includes('ARTICO-MP-ADMIN');
}

export const snakeToCamel = (text: string) =>
  text.toLowerCase().replace(/_([a-z])/g, (_, match) => match.toUpperCase());

export const mapDate = (date) =>
  date ? toDateTimeISO8601(date.split('-').reverse().join('/'), '23:00:00') : null;

export const dispatchErrorMessage = (store: Store, translate: TranslateService): void => {
  store.dispatch(
    commonActions.viewToast({
      message: translate.instant('MP-STORE-TOAST-ERROR'),
    })
  );

};

export function getValueCurrentUserGroups(nameGroup): boolean {
  const data: string[] = localStorageService
    .get('brokerSessionInfo')
    ?.routerInfo?.elements?.map((group: any) => group.name);
  return data?.includes(nameGroup);
}

export function getProductGroup(): string {
  return getProduct()?.productGroup;
}

export function validateCPF(cpf: string): boolean {
  cpf = cpf.replace(/\D/g, '');

  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

  const soma1 = Array.from({ length: 9 }, (_, i) => +cpf[i] * (10 - i)).reduce(
    (acc, val) => acc + val,
    0
  );
  let resto1 = (soma1 * 10) % 11;
  if (resto1 === 10) resto1 = 0;

  const soma2 = Array.from({ length: 10 }, (_, i) => +cpf[i] * (11 - i)).reduce(
    (acc, val) => acc + val,
    0
  );
  let resto2 = (soma2 * 10) % 11;
  if (resto2 === 10) resto2 = 0;

  return resto1 === +cpf[9] && resto2 === +cpf[10];
}

export function formatterCPF(cpf: string): string {
  cpf = cpf.replace(/\D/g, '');

  return `${cpf.substring(0, 3)}.${cpf.substring(3, 6)}.${cpf.substring(6, 9)}-${cpf.substring(
    9,
    11
  )}`;
}

export function formatCurrency(amount: number, coin?: string): string {
  amount = amount ?? 0.0;
  const stringValue = Number(amount).toFixed(2);
  const [integerPart, decimalPart] = stringValue.split('.');

  switch (coin) {
    case 'BRL': {
      let formattedIntegerPart = '';
      for (let i = integerPart.length - 1, j = 0; i >= 0; i -= 1, j += 1) {
        if (j > 0 && j % 3 === 0) {
          formattedIntegerPart = `.${formattedIntegerPart}`;
        }
        formattedIntegerPart = integerPart[i] + formattedIntegerPart;
      }
      let formattedDecimalPart = '';
      if (decimalPart) {
        formattedDecimalPart = `,${decimalPart}`;
      }
      return `R$ ${formattedIntegerPart}${formattedDecimalPart}`;
    }
    case 'PEN': {
      let formatTedIntegerPartPEN = '';
      for (let i = integerPart.length - 1, j = 0; i >= 0; i -= 1, j += 1) {
        if (j > 0 && j % 3 === 0) {
          formatTedIntegerPartPEN = `,${formatTedIntegerPartPEN}`;
        }
        formatTedIntegerPartPEN = integerPart[i] + formatTedIntegerPartPEN;
      }
      let formattedDecimalPartPEN = '';
      if (decimalPart) {
        formattedDecimalPartPEN = `.${decimalPart}`;
      }
      return `S/ ${formatTedIntegerPartPEN}${formattedDecimalPartPEN}`;
    }
    case 'MXN': {
      let formattedIntegerPartMXM = '';
      for (let i = integerPart.length - 1, j = 0; i >= 0; i -= 1, j += 1) {
        if (j > 0 && j % 3 === 0) {
          formattedIntegerPartMXM = `,${formattedIntegerPartMXM}`;
        }
        formattedIntegerPartMXM = integerPart[i] + formattedIntegerPartMXM;
      }
      let formattedDecimalPartMXM = '';
      if (decimalPart) {
        formattedDecimalPartMXM = `.${decimalPart}`;
      }
      return `MEX$ ${formattedIntegerPartMXM}${formattedDecimalPartMXM}`;
    }
    case 'USD': {
      let formattedIntegerPartUSD = '';
      for (let i = integerPart.length - 1, j = 0; i >= 0; i -= 1, j += 1) {
        if (j > 0 && j % 3 === 0) {
          formattedIntegerPartUSD = `,${formattedIntegerPartUSD}`;
        }
        formattedIntegerPartUSD = integerPart[i] + formattedIntegerPartUSD;
      }
      let formattedDecimalPartUSD = '';
      if (decimalPart) {
        formattedDecimalPartUSD = `.${decimalPart}`;
      }
      return `$ ${formattedIntegerPartUSD}${formattedDecimalPartUSD}`;
    }
    default:
      return amount.toFixed(2);
  }
}
export function roundedValue(value: number) {
  return Math.round((value + Number.EPSILON) * 100) / 100;
}

export function clearDiference(diference: number): number {
  return Math.abs(roundedValue(diference));
}

export function isProductionEnvironment(): boolean {
  return env.FRONT_ENV === 'prod';
}

export function decodeStringBase64ToObject(base64String: string): any {
  const decodedBytes = Uint8Array.from(atob(base64String), (c) => c.charCodeAt(0));
  const decodedText = new TextDecoder('utf-8').decode(decodedBytes);
  return JSON.parse(decodedText);
}

export function isValidNumber(val) {
  const str: string = typeof val !== 'string' ? `${val}` : val;
  if (!/^-?[0-9,.]+$/.test(str)) {
    return false;
  }
  if ((str.match(/-/g) || []).length > 1 || (str.includes('-') && str[0] !== '-')) {
    return false;
  }
  if ((str.match(/\./g) || []).length > 1) {
    return false;
  }

  return true;
}

export function isInvalidCEP(cepValue: string): boolean {
  return !cepValue || cepValue.length !== 8 || cepValue === '00000000';
}

export function copyValidators(
  sourceControl: AbstractControl,
  targetControl: AbstractControl
): void {
  if (!sourceControl || !targetControl) return;
  const syncValidators = sourceControl.validator ? [sourceControl.validator] : [];
  const asyncValidators = sourceControl.asyncValidator ? [sourceControl.asyncValidator] : [];
  targetControl.setValidators(syncValidators.length ? syncValidators : null);
  targetControl.setAsyncValidators(asyncValidators.length ? asyncValidators : null);
  targetControl.updateValueAndValidity();
}

export function isLocalEnviroment(): boolean {
  // ! Usado para pruebas en página de certificados apuntando a URL publicas.
  return false;
}

export function getFilteredControls(formGroup: FormGroup, keys: string[]): FormControl[] {
  return keys.map((key) => formGroup.get(key) as FormControl);
}
